import { render, staticRenderFns } from "./SimpleChooseCategory.vue?vue&type=template&id=baff29ec&scoped=true&"
import script from "./SimpleChooseCategory.vue?vue&type=script&lang=js&"
export * from "./SimpleChooseCategory.vue?vue&type=script&lang=js&"
import style0 from "./SimpleChooseCategory.vue?vue&type=style&index=0&id=baff29ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff29ec",
  null
  
)

export default component.exports